import { FormattedNumber } from 'react-intl';
import React from 'react';

export const FormatCurrency: React.SFC<{ currency: string | null, price: number | null, numberClass?: string }> =
    ({currency, price, numberClass}) => {
        if (price === null) {
            return null;
        }

        return (
            <span>
                {currency + ' '}
                <span className={numberClass}>
                    <FormattedNumber
                        value={price}
                        style="decimal"
                        minimumFractionDigits={2}
                        maximumFractionDigits={2}
                    />
                </span>
            </span>
        );
    };
